import { render, staticRenderFns } from "./CustomerAccountCreateOrUpdateContact.vue?vue&type=template&id=25074600"
import script from "./CustomerAccountCreateOrUpdateContact.vue?vue&type=script&lang=js"
export * from "./CustomerAccountCreateOrUpdateContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports